import Axios from "../../axios";
import {bellConstants} from "../../constants/ApiConstant";


export async function editBell(params) {
    return Axios.post(bellConstants.BELL_UPDATE, params);
}

export async function deleteBell(params) {
    return Axios.post(bellConstants.BELL_DELETE, params);
}